module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "ramda"
var external_ramda_ = __webpack_require__("ramda");

// EXTERNAL MODULE: external "react-multi-carousel"
var external_react_multi_carousel_ = __webpack_require__("react-multi-carousel");
var external_react_multi_carousel_default = /*#__PURE__*/__webpack_require__.n(external_react_multi_carousel_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/Review/styles/index.ts
/* eslint-disable @typescript-eslint/no-explicit-any */

var ContentReviewsWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewsWrapper",
  componentId: "vs172k-0"
})(["width:100%;"]);
var StarGroupContainer = external_styled_components_default.a.span.withConfig({
  displayName: "StarGroupContainer",
  componentId: "vs172k-1"
})(["position:relative;right:0px;white-space:nowrap;text-align:left;"]);
var StarGroup = external_styled_components_default.a.span.withConfig({
  displayName: "StarGroup",
  componentId: "vs172k-2"
})(["font-size:", ";overflow:hidden;display:inline-block;vertical-align:bottom;&:before{content:'\\2605\\2605\\2605\\2605\\2605';}", ";"], function (props) {
  return props.size + "px;";
}, function (props) {
  return props.percent ? "width: " + props.percent + "%;" : "";
});
var StarGroupOn = external_styled_components_default()(StarGroup).withConfig({
  displayName: "StarGroupOn",
  componentId: "vs172k-3"
})(["color:#feb948 !important;left:0px;position:absolute;"]);
var StarGroupOff = external_styled_components_default()(StarGroup).withConfig({
  displayName: "StarGroupOff",
  componentId: "vs172k-4"
})(["color:#222222 !important;left:0px;"]);
var ContentYellowBarBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentYellowBarBase",
  componentId: "vs172k-5"
})(["width:30px;height:4px;color:#ffffff;background-color:#fbb649;"]);
var ContentReadMoreYellowBar = external_styled_components_default()(ContentYellowBarBase).withConfig({
  displayName: "ContentReadMoreYellowBar",
  componentId: "vs172k-6"
})(["margin-left:auto;margin-right:auto;"]);
var ContentReviewsOverview = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewsOverview",
  componentId: "vs172k-7"
})(["background-color:white;padding:16px 0px;text-align:center;"]);
var ContentReviewsSections = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewsSections",
  componentId: "vs172k-8"
})(["display:flex;flex-flow:column;text-align:center;margin-left:auto;margin-right:auto;@media (min-width:", "px){width:90%;display:inline-block;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReviewSectionBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewSectionBase",
  componentId: "vs172k-9"
})(["background-color:", ";padding:19px 0px;order:1;position:relative;vertical-align:top;& h3 span{display:block;height:18px;color:#183558;font-family:'Brandon Text';font-size:24px;font-weight:700;line-height:26px;text-transform:uppercase;margin-top:19px;padding-bottom:1em;}& h3{color:#757989;font-family:'Brandon Text';font-size:22px;font-weight:300;}"], function (props) {
  return props.whiteBackground ? '#ffffff' : 'auto';
});
var ContentReadMoreOverview = external_styled_components_default()(ContentReviewSectionBase).withConfig({
  displayName: "ContentReadMoreOverview",
  componentId: "vs172k-10"
})(["order:1;@media (min-width:", "px){text-align:center;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReviewArea = external_styled_components_default()(ContentReviewSectionBase).withConfig({
  displayName: "ContentReviewArea",
  componentId: "vs172k-11"
})(["&&{width:100%;min-width:", ";margin-top:2em;", ";}@media (min-width:", "px){&&{", ";}}"], function (props) {
  return props.minWidth;
}, function (props) {
  return props.isModal ? 'padding: 2em' : '';
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return !props.isModal ? 'padding: 1em' : '';
});
var ContentReviewAreaPlaceholder = external_styled_components_default()(ContentReviewArea).withConfig({
  displayName: "ContentReviewAreaPlaceholder",
  componentId: "vs172k-12"
})(["&&{min-width:", ";}"], function (props) {
  return props.minWidth;
});
var ContentReviewStars = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewStars",
  componentId: "vs172k-13"
})(["position:relative;&&{order:", ";text-align:left;width:100%;}"], function (props) {
  return props.order;
});
var ReviewStarsTextBase = external_styled_components_default.a.span.withConfig({
  displayName: "ReviewStarsTextBase",
  componentId: "vs172k-14"
})(["left:0px;color:#183558;font-family:'Brandon Text';font-size:14px;font-weight:700;text-transform:uppercase;letter-spacing:0.35px;text-align:left;display:inline-block;whitespace:nowrap;"]);
var ReviewStarsText = external_styled_components_default()(ReviewStarsTextBase).withConfig({
  displayName: "ReviewStarsText",
  componentId: "vs172k-15"
})(["width:50%;"]);
var ReviewsOverviewStarsText = external_styled_components_default()(ReviewStarsTextBase).withConfig({
  displayName: "ReviewsOverviewStarsText",
  componentId: "vs172k-16"
})(["color:#757989;font-weight:400;"]);
var ContentReviewItemHeaderNameDate = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewItemHeaderNameDate",
  componentId: "vs172k-17"
})(["top:0px;position:absolute;height:13px;font-family:'Brandon Text';line-height:18px;text-transform:uppercase;"]);
var ContentReviewCustomerName = external_styled_components_default()(ContentReviewItemHeaderNameDate).withConfig({
  displayName: "ContentReviewCustomerName",
  componentId: "vs172k-18"
})(["left:0px;color:#183558;font-size:16px;font-weight:700;", ";@media (min-width:", "px){font-size:20px;padding-left:0.8em;}"], function (props) {
  return props.isModal ? 'padding-left: 2em' : '';
}, function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReviewDate = external_styled_components_default()(ContentReviewItemHeaderNameDate).withConfig({
  displayName: "ContentReviewDate",
  componentId: "vs172k-19"
})(["right:0px;color:#757989;font-size:14px;font-weight:200;", ";@media (min-width:", "px){padding-right:1em;}"], function (props) {
  return props.isModal ? 'padding-right: 2em' : '';
}, function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReviewCustomerVehicleLocationWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewCustomerVehicleLocationWrapper",
  componentId: "vs172k-20"
})(["position:relative;margin-top:0.25em;margin-bottom:2em;"]);
var ContentReviewItemHeaderVehicleLocation = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewItemHeaderVehicleLocation",
  componentId: "vs172k-21"
})(["top:0px;position:absolute;height:13px;font-family:'Brandon Text';line-height:18px;"]);
var ContentReviewCustomerVehicle = external_styled_components_default()(ContentReviewItemHeaderVehicleLocation).withConfig({
  displayName: "ContentReviewCustomerVehicle",
  componentId: "vs172k-22"
})(["right:0px;color:#757989;font-size:12px;font-weight:200;"]);
var ContentReviewCustomerLocation = external_styled_components_default()(ContentReviewItemHeaderVehicleLocation).withConfig({
  displayName: "ContentReviewCustomerLocation",
  componentId: "vs172k-23"
})(["left:0px;color:#757989;font-size:12px;font-weight:200;"]);
var ContentReviewBody = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewBody",
  componentId: "vs172k-24"
})(["color:#757989;font-family:'Brandon Text';font-size:14px;font-weight:400;line-height:20px;letter-spacing:0.35px;text-align:left;max-height:", ";overflow:hidden;margin-top:1em;position:relative;&:before{cursor:default;background-image:", ";content:'';height:3em;left:0;position:absolute;width:100%;top:3em;}@media (min-width:", "px){min-height:", ";}"], function (props) {
  return props.restrictHeight ? '6em' : 'auto';
}, function (props) {
  return props.useFade ? 'linear-gradient(180deg,hsla(0,0%,100%,0),#ffffff)' : '';
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.restrictHeight ? '6em' : 'auto';
});
var ContentReviewBodyEllipsis = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewBodyEllipsis",
  componentId: "vs172k-25"
})(["color:#757989;font-family:'Brandon Text';font-size:14px;font-weight:400;line-height:20px;letter-spacing:0.35px;text-align:left;"]);
var ContentReviewReadMoreButton = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewReadMoreButton",
  componentId: "vs172k-26"
})(["color:#00aed9;font-family:'Brandon Text';font-size:14px;font-weight:700;text-transform:uppercase;text-align:left;margin-top:1em;position:relative;cursor:pointer;&:after{background-image:", ";bottom:28px;content:'';height:3em;left:0;position:absolute;width:100%;}"], function (props) {
  return props.useFade ? 'linear-gradient(180deg,hsla(0,0%,100%,0),#ffffff)' : '';
});
var ContentReviewSectionSeparatorBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewSectionSeparatorBase",
  componentId: "vs172k-27"
})(["height:1px;background-color:#d9dde9;width:100%;margin-top:1em;margin-bottom:1em;"]);
var ContentReviewSectionSeparator = external_styled_components_default()(ContentReviewSectionSeparatorBase).withConfig({
  displayName: "ContentReviewSectionSeparator",
  componentId: "vs172k-28"
})(["order:", ";"], function (props) {
  return props.order;
});
var CarouselItem = external_styled_components_default.a.div.withConfig({
  displayName: "CarouselItem",
  componentId: "vs172k-29"
})(["outline:0px;display:flex;flex-flow:column nowrap;align-items:center;overflow:hidden;background:", ";width:", "px;background:#f4f8fa;border-radius:3px;position:relative;margin:", ";background-color:#ffffff;padding:1em;@media (min-width:", "px){flex-flow:row nowrap;align-items:flex-start;}"], function (props) {
  return props.theme.carvana.white.primary;
}, function (props) {
  return props.itemWidth - props.margin * 2;
}, function (props) {
  return "0 " + props.margin + "px";
}, function (props) {
  return props.theme.breakpoints.values.sm;
});
var CarouselWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "CarouselWrapper",
  componentId: "vs172k-30"
})(["display:flex;flex-direction:column;align-items:center;order:2;.slider{padding-bottom:40px;}.slider-control-centerleft{bottom:3% !important;left:5% !important;top:auto !important;}.slider-control-centerright{bottom:3% !important;right:15% !important;top:auto !important;}.slider-control-bottomcenter{.paging-item{span{background:", " !important;}&.active{span{background:", " !important;}}}}& .reviews-carousel-container{width:90%;margin:0 auto;padding-bottom:90px;}& .react-multi-carousel-list{display:flex;align-items:center;overflow:hidden;position:relative;}& .react-multi-carousel-track{list-style:none;padding:0;margin:0;display:flex;flex-direction:row;position:relative;transform-style:preserve-3d;backface-visibility:hidden;will-change:transform,transition;}& .react-multiple-carousel__arrow{position:absolute;bottom:0;outline:0;transition:all 0.5s;border-radius:35px;border:0;background:rgb(255,255,255);min-width:43px;min-height:43px;opacity:1;cursor:pointer;box-shadow:rgba(25,41,61,0.15) 0px 14px 23px 1px;transition:transform 200ms ease,color 200ms ease;transform:scale(0.9) translateY(-50%);}& .react-multiple-carousel__arrow:hover{transform:scale(1) translateY(-48%);}& .react-multiple-carousel__arrow::before{display:block;color:rgb(0,174,217);text-align:center;z-index:2;position:relative;}& .react-multiple-carousel__arrow--left{left:calc(4% + 1px);}& .react-multiple-carousel__arrow--left::before{top:3px;left:0px;content:url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgaGVpZ2h0PSIxNyIgd2lkdGg9IjE3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiMwMGFlZDkiPjxwYXRoIGQ9Ik01LjE5IDEwYS44LjggMCAwIDEtLjU1LS4yM0wuMjYgNS40OEEuOS45IDAgMCAxIDAgNC44NGEuOTIuOTIgMCAwIDEgLjI4LS42M2w0LjM4LTRBLjc3Ljc3IDAgMCAxIDUuOC4zYS44Ny44NyAwIDAgMS0uMDggMS4yTDIgNC44OGwzLjc0IDMuNjRhLjg4Ljg4IDAgMCAxIDAgMS4yMS43Ni43NiAwIDAgMS0uNTkuMjciPjwvcGF0aD48L2c+PC9zdmc+);}& .react-multiple-carousel__arrow--right{right:calc(4% + 1px);}& .react-multiple-carousel__arrow--right::before{top:3px;right:0px;content:url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgaGVpZ2h0PSIxNyIgd2lkdGg9IjE3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiMwMGFlZDkiPjxwYXRoIGQ9Ik0uODEgMTBhLjc0Ljc0IDAgMCAwIC41NS0uMjNsNC4zOC00LjI5QS44OS44OSAwIDAgMCA2IDQuODRhLjg0Ljg0IDAgMCAwLS4yOC0uNjNsLTQuMzgtNEEuNzcuNzcgMCAwIDAgLjIuM2EuODguODggMCAwIDAgLjA4IDEuMkw0IDQuODguMjYgOC41MmEuODguODggMCAwIDAgMCAxLjIxLjc4Ljc4IDAgMCAwIC41NS4yNyI+PC9wYXRoPjwvZz48L3N2Zz4=);}& .react-multi-carousel-dot-list{position:absolute;bottom:28px;display:flex;left:0;right:0;justify-content:center;margin:auto;padding:0;margin-left:25%;margin-right:25%;list-style:none;text-align:center;}& .react-multi-carousel-dot button{display:inline-block;width:6px;height:6px;border-radius:50%;opacity:1;padding:0;box-shadow:none;transition:background 0.5s;border-width:0px;background:rgb(170,177,199);margin:0 7px;outline:0;cursor:pointer;}& .react-multi-carousel-dot--active button{background:rgb(0,174,217);}& .react-multi-carousel-item{transform-style:preserve-3d;backface-visibility:hidden;}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){& .react-multi-carousel-item{flex-shrink:0 !important;}& .react-multi-carousel-track{overflow:visible !important;}}@media (min-width:", "px){padding-bottom:0;.slider-control-centerleft{left:5% !important;}.slider-control-centerright{right:10% !important;}}"], function (props) {
  return props.theme.carvana.gray.medium;
}, function (props) {
  return props.theme.carvana.blue.primary;
}, function (props) {
  return props.theme.breakpoints.values.lg;
});
var SeeAllReviewsLink = external_styled_components_default.a.a.withConfig({
  displayName: "SeeAllReviewsLink",
  componentId: "vs172k-31"
})(["color:#00aed9;font-family:'Brandon Text';font-size:14px;font-weight:700;text-transform:uppercase;text-align:left;margin-top:1em;position:relative;cursor:pointer;&:hover{text-decoration:none;color:#00aed9;}"]);
var ReviewsOverviewArea = external_styled_components_default()(ContentReviewSectionBase).withConfig({
  displayName: "ReviewsOverviewArea",
  componentId: "vs172k-32"
})(["order:1;padding:0px;flex-direction:row;align-items:baseline;display:flex;margin-left:auto;margin-right:auto;flex-wrap:wrap;justify-content:center;"]);
var ReviewsOverviewAreaStars = external_styled_components_default.a.div.withConfig({
  displayName: "ReviewsOverviewAreaStars",
  componentId: "vs172k-33"
})(["display:inline-block;text-align:left;margin-right:1em;"]);
var ReviewsOverviewTitle = external_styled_components_default.a.span.withConfig({
  displayName: "ReviewsOverviewTitle",
  componentId: "vs172k-34"
})(["color:#183558;font-family:'Brandon Text';font-size:16px;font-weight:700;white-space:nowrap;width:100%;@media (min-width:", "px){width:auto;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
// EXTERNAL MODULE: external "fecha"
var external_fecha_ = __webpack_require__("fecha");
var external_fecha_default = /*#__PURE__*/__webpack_require__.n(external_fecha_);

// EXTERNAL MODULE: external "@carvana/modal"
var modal_ = __webpack_require__("@carvana/modal");

// CONCATENATED MODULE: ./src/Review/ReviewStars.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */



var ReviewStars_ReviewStarsRange = function ReviewStarsRange(_ref) {
  var _ref$score = _ref.score,
      score = _ref$score === void 0 ? 0 : _ref$score,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? false : _ref$large;
  var px = large ? 20 : 16;
  var pct = 100.0 * score / 5.0;
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    className: className
  }, /*#__PURE__*/external_react_default.a.createElement(StarGroupContainer, null, /*#__PURE__*/external_react_default.a.createElement(StarGroupOff, {
    size: px
  }), /*#__PURE__*/external_react_default.a.createElement(StarGroupOn, {
    size: px,
    percent: pct
  })));
};
var ReviewStars = external_styled_components_default()(ReviewStars_ReviewStarsRange).withConfig({
  displayName: "ReviewStars",
  componentId: "req9b4-0"
})(["&&{width:50%;text-align:right;display:inline-block;}"]);
var ReviewStarsOverall = external_styled_components_default()(ReviewStars_ReviewStarsRange).withConfig({
  displayName: "ReviewStarsOverall",
  componentId: "req9b4-1"
})(["&&{display:inline-block;padding-right:1em;@media (min-width:500px){padding-left:1em;}}"]);
/* harmony default export */ var Review_ReviewStars = (ReviewStars_ReviewStarsRange);
// CONCATENATED MODULE: ./src/ReviewModal/styles/index.ts
/* eslint-disable @typescript-eslint/no-explicit-any */

var styles_ContentReviewItemHeaderNameDate = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewItemHeaderNameDate",
  componentId: "yxmnw8-0"
})(["top:0px;position:absolute;height:13px;font-family:'Brandon Text';line-height:18px;"]);
var ReviewModalWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ReviewModalWrapper",
  componentId: "yxmnw8-1"
})(["& .modal-root{display:flex !important;}"]);
var styles_ContentReviewCustomerName = external_styled_components_default()(styles_ContentReviewItemHeaderNameDate).withConfig({
  displayName: "ContentReviewCustomerName",
  componentId: "yxmnw8-2"
})(["left:0px;color:#183558;font-size:16px;font-weight:700;", ";@media (min-width:", "px){font-size:20px;padding-left:0.8em;}"], function (props) {
  return props.isModal ? 'padding-left: 2em' : '';
}, function (props) {
  return props.theme.breakpoints.values.sm;
});
var styles_ContentReviewDate = external_styled_components_default()(styles_ContentReviewItemHeaderNameDate).withConfig({
  displayName: "ContentReviewDate",
  componentId: "yxmnw8-3"
})(["right:0px;color:#757989;font-size:14px;font-weight:200;", ";@media (min-width:", "px){padding-right:1em;}"], function (props) {
  return props.isModal ? 'padding-right: 2em' : '';
}, function (props) {
  return props.theme.breakpoints.values.sm;
});
var styles_ContentReviewSectionBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewSectionBase",
  componentId: "yxmnw8-4"
})(["background-color:", ";padding:19px 0px;order:1;position:relative;vertical-align:top;& h3 span{display:block;height:18px;color:#183558;font-family:'Brandon Text';font-size:24px;font-weight:700;line-height:26px;text-transform:uppercase;margin-top:19px;padding-bottom:1em;}& h3{color:#757989;font-family:'Brandon Text';font-size:22px;font-weight:300;}"], function (props) {
  return props.whiteBackground ? '#ffffff' : 'auto';
});
var styles_ContentReviewArea = external_styled_components_default()(styles_ContentReviewSectionBase).withConfig({
  displayName: "ContentReviewArea",
  componentId: "yxmnw8-5"
})(["&&{min-width:", ";order:", ";margin-top:2em;", ";}@media (min-width:", "px){&&{", ";", ";}}"], function (props) {
  return props.minWidth;
}, function (props) {
  return props.order;
}, function (props) {
  return props.isModal ? 'padding: 2em' : '';
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return !props.isModal ? 'padding: 1em' : '';
}, function (props) {
  return !props.isModal ? 'width: 100%' : '';
});
var styles_ContentReviewCustomerVehicleLocationWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewCustomerVehicleLocationWrapper",
  componentId: "yxmnw8-6"
})(["position:relative;margin-top:0.25em;margin-bottom:2em;"]);
var styles_ContentReviewItemHeaderVehicleLocation = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewItemHeaderVehicleLocation",
  componentId: "yxmnw8-7"
})(["top:0px;position:absolute;height:13px;font-family:'Brandon Text';line-height:18px;"]);
var styles_ContentReviewCustomerVehicle = external_styled_components_default()(styles_ContentReviewItemHeaderVehicleLocation).withConfig({
  displayName: "ContentReviewCustomerVehicle",
  componentId: "yxmnw8-8"
})(["right:0px;color:#757989;font-size:12px;font-weight:200;"]);
var styles_ContentReviewCustomerLocation = external_styled_components_default()(styles_ContentReviewItemHeaderVehicleLocation).withConfig({
  displayName: "ContentReviewCustomerLocation",
  componentId: "yxmnw8-9"
})(["left:0px;color:#757989;font-size:12px;font-weight:200;"]);
var styles_ContentReviewBody = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewBody",
  componentId: "yxmnw8-10"
})(["color:#757989;font-family:'Brandon Text';font-size:14px;font-weight:400;line-height:20px;letter-spacing:0.35px;text-align:left;max-height:", ";overflow:hidden;margin-top:1em;@media (min-width:", "px){min-height:", ";}"], function (props) {
  return props.restrictHeight ? '6em' : 'auto';
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.restrictHeight ? '6em' : 'auto';
});
var styles_ContentReviewSectionSeparatorBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewSectionSeparatorBase",
  componentId: "yxmnw8-11"
})(["height:1px;background-color:#d9dde9;width:100%;margin-top:1em;margin-bottom:1em;"]);
var styles_ContentReviewSectionSeparator = external_styled_components_default()(styles_ContentReviewSectionSeparatorBase).withConfig({
  displayName: "ContentReviewSectionSeparator",
  componentId: "yxmnw8-12"
})(["order:", ";"], function (props) {
  return props.order;
});
var styles_ReviewStarsTextBase = external_styled_components_default.a.span.withConfig({
  displayName: "ReviewStarsTextBase",
  componentId: "yxmnw8-13"
})(["left:0px;color:#183558;font-family:'Brandon Text';font-size:14px;font-weight:700;text-transform:uppercase;letter-spacing:0.35px;text-align:left;display:inline-block;whitespace:nowrap;"]);
var styles_ReviewStarsText = external_styled_components_default()(styles_ReviewStarsTextBase).withConfig({
  displayName: "ReviewStarsText",
  componentId: "yxmnw8-14"
})(["width:50%;"]);
var styles_ContentReviewStars = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReviewStars",
  componentId: "yxmnw8-15"
})(["position:relative;&&{order:", ";text-align:left;width:100%;}"], function (props) {
  return props.order;
});
// CONCATENATED MODULE: ./src/ReviewModal/ReviewModal.tsx
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








var ReviewModal_ReviewModal = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(ReviewModal, _PureComponent);

  function ReviewModal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _this.toggleModal = function () {
      var onClose = _this.props.onClose;
      onClose();
    };

    return _this;
  }

  var _proto = ReviewModal.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        isOpen = _this$props.isOpen,
        text = _this$props.text,
        name = _this$props.name,
        location = _this$props.location,
        score = _this$props.score,
        date = _this$props.date,
        year = _this$props.year,
        make = _this$props.make,
        model = _this$props.model;
    var vehicle = year + " " + make + " " + model;
    var reviewTextModified = text.length > 1000 ? Object(external_ramda_["take"])(1000, text) + "..." : text;
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(ReviewModalWrapper, null, /*#__PURE__*/external_react_default.a.createElement(modal_["Modal"], {
      toggleModal: function toggleModal() {
        return _this2.toggleModal();
      },
      disableBackdropClick: false,
      fullscreenOnMobile: true,
      open: isOpen,
      headerText: "",
      modalTestName: "review-modal"
    }, /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewArea, {
      isModal: true
    }, /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewCustomerName, {
      isModal: true
    }, name), /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewDate, {
      isModal: true
    }, date), /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewCustomerVehicleLocationWrapper, null, /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewCustomerVehicle, null, "" + vehicle), /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewCustomerLocation, null, location)), /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewBody, {
      restrictHeight: false
    }, reviewTextModified), /*#__PURE__*/external_react_default.a.createElement(ContentReviewSectionSeparator, null), /*#__PURE__*/external_react_default.a.createElement(styles_ContentReviewStars, null, /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(styles_ReviewStarsText, null, parseFloat(score).toFixed(1) + " OUT OF 5"), /*#__PURE__*/external_react_default.a.createElement(ReviewStars, {
      score: score
    })))))));
  };

  return ReviewModal;
}(external_react_["PureComponent"]);

/* harmony default export */ var src_ReviewModal_ReviewModal = (ReviewModal_ReviewModal);
// CONCATENATED MODULE: ./src/ReviewModal/index.ts

/* harmony default export */ var src_ReviewModal = (src_ReviewModal_ReviewModal);
// CONCATENATED MODULE: ./src/Review/ContentReview.tsx
function ContentReview_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







var ContentReview_ContentReview = /*#__PURE__*/function (_PureComponent) {
  ContentReview_inheritsLoose(ContentReview, _PureComponent);

  function ContentReview() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.state = {
      isReviewModalOpen: false
    };

    _this.readMoreClick = function (e) {
      e.preventDefault();
      e.stopPropagation(); // const { item } = this.props;
      // const payload = { selectedReview: item };
      // this.showModal();
    };

    return _this;
  }

  var _proto = ContentReview.prototype;

  _proto.setIsReviewModal = function setIsReviewModal(show) {
    this.setState({
      isReviewModalOpen: show
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        item = _this$props.item,
        order = _this$props.order,
        useEllipsis = _this$props.useEllipsis,
        useFade = _this$props.useFade;
    var isReviewModalOpen = this.state.isReviewModalOpen;
    var reviewText = item.review_text,
        reviewScore = item.review_score,
        reviewDate = item.review_date,
        _item$vehicle = item.vehicle,
        year = _item$vehicle.year,
        make = _item$vehicle.make,
        model = _item$vehicle.model,
        _item$customer = item.customer,
        name = _item$customer.name,
        location = _item$customer.location;
    var score = parseFloat(reviewScore);
    return /*#__PURE__*/external_react_default.a.createElement(ContentReviewArea, {
      order: order,
      key: "review_area_" + name // minWidth={392}

    }, /*#__PURE__*/external_react_default.a.createElement(ContentReviewCustomerName, null, name), /*#__PURE__*/external_react_default.a.createElement(ContentReviewDate, null, external_fecha_default.a.format(new Date(reviewDate), 'mediumDate').toUpperCase()), /*#__PURE__*/external_react_default.a.createElement(ContentReviewCustomerVehicleLocationWrapper, null, /*#__PURE__*/external_react_default.a.createElement(ContentReviewCustomerVehicle, null, year + " " + make + " " + model), /*#__PURE__*/external_react_default.a.createElement(ContentReviewCustomerLocation, null, location)), /*#__PURE__*/external_react_default.a.createElement(ContentReviewBody, {
      restrictHeight: true,
      useFade: true
    }, "" + reviewText), useEllipsis && !useFade ? /*#__PURE__*/external_react_default.a.createElement(ContentReviewBodyEllipsis, null, "...") : null, /*#__PURE__*/external_react_default.a.createElement(ContentReviewReadMoreButton, {
      "data-cv-test": "Cv.Search.ContentReviews.Reviews." + order + ".ReadMoreButton",
      useFade: true,
      onClick: function onClick() {
        return _this2.setIsReviewModal(true);
      }
    }, "Read More"), /*#__PURE__*/external_react_default.a.createElement(ContentReviewSectionSeparator, null), /*#__PURE__*/external_react_default.a.createElement(ContentReviewStars, null, /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(ReviewStarsText, null, score.toFixed(1) + " OUT OF 5"), /*#__PURE__*/external_react_default.a.createElement(ReviewStars, {
      score: score
    }))), /*#__PURE__*/external_react_default.a.createElement(src_ReviewModal, {
      isOpen: isReviewModalOpen,
      onClose: function onClose() {
        return _this2.setIsReviewModal(false);
      },
      text: reviewText,
      name: name,
      location: location,
      score: reviewScore,
      date: external_fecha_default.a.format(new Date(reviewDate), 'mediumDate').toUpperCase(),
      year: year,
      make: make,
      model: model
    }));
  };

  return ContentReview;
}(external_react_["PureComponent"]);

ContentReview_ContentReview.defaultProps = {
  useEllipsis: false,
  useFade: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  trackEvent: function trackEvent() {}
};
/* harmony default export */ var Review_ContentReview = (ContentReview_ContentReview);
// CONCATENATED MODULE: ./src/Review/OverallReviewArea.tsx




var OverallReviewArea_OverallReviewArea = function OverallReviewArea(_ref) {
  var score = _ref.score,
      count = _ref.count;
  return /*#__PURE__*/external_react_default.a.createElement(ReviewsOverviewArea, null, /*#__PURE__*/external_react_default.a.createElement(ReviewsOverviewTitle, null, "OVERALL RATING"), /*#__PURE__*/external_react_default.a.createElement(ReviewStarsOverall, {
    score: score,
    large: true
  }), /*#__PURE__*/external_react_default.a.createElement(ReviewsOverviewStarsText, null, score.toFixed(1) + " OUT OF 5 (" + count + " Reviews)"));
};

OverallReviewArea_OverallReviewArea.defaultProps = {};
/* harmony default export */ var Review_OverallReviewArea = (OverallReviewArea_OverallReviewArea);
// CONCATENATED MODULE: ./src/Review/ContentReviewsHeader.tsx
/* eslint no-nested-ternary:0 */


function ContentReviewsHeader(_ref) {
  var shouldRender = _ref.shouldRender,
      reviewsTitle = _ref.reviewsTitle;

  if (!shouldRender) {
    var nextTag = reviewsTitle || 'Used Car Reviews';
    var nextTagModified = nextTag === reviewsTitle ? Object(external_ramda_["replace"])(/USED\s/i, '', nextTag) + " Reviews" : nextTag;
    return /*#__PURE__*/external_react_default.a.createElement("h2", {
      "data-cv-test": "Cv.ContentReviews.Header"
    }, /*#__PURE__*/external_react_default.a.createElement("span", null, nextTagModified));
  }

  return null;
}
/* harmony default export */ var Review_ContentReviewsHeader = (ContentReviewsHeader);
// EXTERNAL MODULE: external "react-google-structured-data"
var external_react_google_structured_data_ = __webpack_require__("react-google-structured-data");
var external_react_google_structured_data_default = /*#__PURE__*/__webpack_require__.n(external_react_google_structured_data_);

// CONCATENATED MODULE: ./src/Review/ContentReviewsStructuredData.tsx



var ContentReviewsStructuredData_ContentReviewsStructuredData = function ContentReviewsStructuredData(_ref) {
  var hasReviews = _ref.hasReviews,
      flags = _ref.flags,
      reviewMake = _ref.reviewMake,
      reviewModel = _ref.reviewModel,
      overallAverage = _ref.overallAverage,
      overallCount = _ref.overallCount,
      highestRating = _ref.highestRating,
      lowestRating = _ref.lowestRating;
  var isOneMake = !flags.isMultiMake && !flags.isNoMake;
  var isOneModel = isOneMake && flags.isSingleModel && !flags.isAllModels;
  var reviewVehicleName = isOneModel ? reviewMake + " " + reviewModel : reviewMake;
  var reviewsStructuredData = {
    '@context': 'http://schema.org',
    '@type': 'Review',
    itemReviewed: {
      '@type': 'Car',
      name: reviewVehicleName,
      brand: reviewMake,
      model: isOneModel ? reviewModel : '',
      vehicleModelDate: ''
    },
    reviewRating: {
      '@type': 'AggregateRating',
      ratingValue: parseFloat(overallAverage).toFixed(2),
      ratingCount: overallCount,
      worstRating: parseFloat(lowestRating).toFixed(2),
      bestRating: parseFloat(highestRating).toFixed(2)
    },
    author: {
      '@type': 'Organization',
      name: 'Carvana'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Carvana'
    }
  };
  var shouldRenderStructuredData = !flags.hasCvnaid && isOneMake && hasReviews;
  return shouldRenderStructuredData ? /*#__PURE__*/external_react_default.a.createElement(external_react_google_structured_data_default.a, {
    data: reviewsStructuredData
  }) : null;
};

/* harmony default export */ var Review_ContentReviewsStructuredData = (ContentReviewsStructuredData_ContentReviewsStructuredData);
// CONCATENATED MODULE: ./src/Review/ContentReviews.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */








var responsive = {
  wideDesktop: {
    breakpoint: {
      max: 9000,
      min: 1200
    },
    items: 3,
    slidesToSlide: 3
  },
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1200
    },
    items: 3,
    slidesToSlide: 3
  },
  tablet: {
    breakpoint: {
      max: 1200,
      min: 800
    },
    items: 2,
    slidesToSlide: 2
  },
  mobile: {
    breakpoint: {
      max: 800,
      min: 0
    },
    items: 1,
    slidesToSlide: 1
  }
};
var ContentReviews_ContentReviews = function ContentReviews(_ref) {
  var contentReviews = _ref.contentReviews,
      overallAverage = _ref.overallAverage,
      overallCount = _ref.overallCount,
      hasCvnaid = _ref.hasCvnaid,
      seoData = _ref.seoData,
      trackEvent = _ref.trackEvent,
      highestRating = _ref.highestRating,
      lowestRating = _ref.lowestRating,
      showStructuredData = _ref.showStructuredData;
  var reviews = contentReviews || [];
  var flags = seoData.flags;
  var vehicle = reviews[0].vehicle;
  var reviewMake = vehicle.make,
      reviewModel = vehicle.model;
  var hasReviews = !Object(external_ramda_["isEmpty"])(reviews);

  var _useState = Object(external_react_["useState"])(0),
      prevSlide = _useState[0],
      setPrevSlide = _useState[1];

  var _useState2 = Object(external_react_["useState"])(1),
      currentSlide = _useState2[0],
      setCurrentSlide = _useState2[1];

  var isInitialRender = Object(external_react_["useRef"])(true);
  Object(external_react_["useEffect"])(function () {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    var slideDirection = prevSlide < currentSlide ? 'Next' : 'Previous';
    trackEvent("SEOReviews - " + slideDirection + " Arrow Click", {
      eventCategory: 'SEOReviews',
      eventAction: 'click',
      eventLabel: "Reviews Carousel " + slideDirection + " Arrow"
    });
  }, [currentSlide]);
  return !hasReviews ? null : /*#__PURE__*/external_react_default.a.createElement(ContentReviewsWrapper, {
    "data-cv-test": "Cv.Search.ContentReviews.Wrapper"
  }, /*#__PURE__*/external_react_default.a.createElement(ContentReviewsOverview, null, showStructuredData ? /*#__PURE__*/external_react_default.a.createElement(Review_ContentReviewsStructuredData, {
    hasReviews: hasReviews,
    flags: flags,
    reviewMake: reviewMake,
    reviewModel: reviewModel,
    overallAverage: overallAverage.toString(),
    overallCount: overallCount.toString(),
    highestRating: highestRating,
    lowestRating: lowestRating
  }) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, " "), /*#__PURE__*/external_react_default.a.createElement(ContentReviewsSections, null, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreOverview, null, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreYellowBar, null), /*#__PURE__*/external_react_default.a.createElement(Review_ContentReviewsHeader, {
    shouldRender: hasCvnaid,
    reviewsTitle: seoData.seoH1
  })), /*#__PURE__*/external_react_default.a.createElement(Review_OverallReviewArea, {
    score: overallAverage,
    count: overallCount
  }), /*#__PURE__*/external_react_default.a.createElement(CarouselWrapper, null, /*#__PURE__*/external_react_default.a.createElement(external_react_multi_carousel_default.a, {
    afterChange: function afterChange(previousSlide, state) {
      setPrevSlide(previousSlide);
      setCurrentSlide(state.currentSlide);
    },
    additionalTransfrom: 0,
    arrows: true,
    autoPlaySpeed: 3000,
    centerMode: false,
    containerClass: "reviews-carousel-container",
    draggable: true,
    focusOnSelect: false,
    infinite: false,
    itemClass: "reviews-carousel-item",
    keyBoardControl: true,
    minimumTouchDrag: 80,
    partialVisible: true,
    renderButtonGroupOutside: false,
    renderDotsOutside: false,
    responsive: responsive,
    showDots: true,
    sliderClass: "",
    slidesToSlide: 3,
    ssr: true,
    swipeable: true,
    deviceType: "mobile"
  }, contentReviews.map(function (review) {
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      key: review.review_title
    }, /*#__PURE__*/external_react_default.a.createElement(Review_ContentReview, {
      item: review,
      useFade: true
    }));
  })), /*#__PURE__*/external_react_default.a.createElement(SeeAllReviewsLink, {
    href: "/reviews"
  }, "See all customers reviews")))));
};
/* harmony default export */ var Review_ContentReviews = (ContentReviews_ContentReviews);
// CONCATENATED MODULE: ./src/Review/index.ts

/* harmony default export */ var Review = (Review_ContentReviews);
// CONCATENATED MODULE: ./src/index.ts

/* harmony default export */ var src = __webpack_exports__["default"] = (Review);

/***/ }),

/***/ "@carvana/modal":
/***/ (function(module, exports) {

module.exports = require("@carvana/modal");

/***/ }),

/***/ "fecha":
/***/ (function(module, exports) {

module.exports = require("fecha");

/***/ }),

/***/ "ramda":
/***/ (function(module, exports) {

module.exports = require("ramda");

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-google-structured-data":
/***/ (function(module, exports) {

module.exports = require("react-google-structured-data");

/***/ }),

/***/ "react-multi-carousel":
/***/ (function(module, exports) {

module.exports = require("react-multi-carousel");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map